/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type GlobalMessageTemplateResource = {
    /**
     * Transform the resource into an array.
     */
    id: number
    name: string
    subject: string
    category: string
    from: string
    reply_to: string
    content: Record<string, any>
    type: GlobalMessageTemplateResource.type
    helm_user_id: number
    previous_id: number
    created_at: string
    updated_at: string | null
    deleted_at: string | null
}

export namespace GlobalMessageTemplateResource {
    export enum type {
        SMS = 'sms',
        UNLAYER = 'unlayer',
        HTML = 'html',
        TEXT = 'text'
    }
}
